/**
 * DRT Bodywear – Theme script
 * Mobile menu toggle, product variant switch, cookie preference (placeholder)
 */

(function () {
  'use strict';

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('[data-drawer]');

  if (menuToggle && drawer) {
    menuToggle.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      drawer.setAttribute('aria-hidden', expanded);
      document.body.style.overflow = expanded ? '' : 'hidden';
    });
  }

  document.querySelector('[data-cookie-preference]')?.addEventListener('click', function () {
    console.info('Cookie preference – connect to your consent solution');
  });

  // Product page: open Size Guide accordion when "Size Guide" button is clicked
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = this.getAttribute('data-accordion-trigger');
      var details = id ? document.getElementById(id) : null;
      if (details && details.tagName === 'DETAILS') {
        details.open = true;
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Product form: update variant id, price, availability when options change; show indicator on submit
  const form = document.querySelector('[data-product-form]');
  if (form) {
    const addBtn = form.querySelector('[data-add-to-cart]');
    form.addEventListener('submit', function () {
      if (addBtn && !addBtn.disabled) {
        addBtn.classList.add('is-loading');
      }
    });
    const jsonEl = document.querySelector('[data-product-json]');
    const variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    const optionInputs = form.querySelectorAll('input[name]:not([name="id"]):not([name="quantity"])');
    const variantIdInput = form.querySelector('[data-variant-id]');
    const priceEl = form.querySelector('[data-price]');
    const comparePriceEl = form.querySelector('[data-compare-price]');
    const priceContainer = form.querySelector('[data-product-price]');

    function formatMoney(cents) {
      var format = window.Shopify && window.Shopify.money_format;
      if (format) {
        var value = (cents / 100).toFixed(2);
        return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
          if (key === 'amount') return value;
          if (key === 'amount_no_decimals') return Math.round(cents / 100);
          if (key === 'amount_with_comma_separator') return value.replace('.', ',');
          if (key === 'amount_no_decimals_with_comma_separator') return Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return value;
        });
      }
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency) || 'USD'
      }).format(cents / 100);
    }

    function setVariant(variant) {
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        var textEl = addBtn.querySelector('.main-product__add-text');
        var text = variant.available
          ? (addBtn.dataset.addText || 'Add to cart')
          : (addBtn.dataset.soldOut || 'Sold out');
        if (textEl) textEl.textContent = text; else addBtn.textContent = text;
      }
    }

    const optionNames = (form.getAttribute('data-option-names') || '').split(',').filter(Boolean);

    function getSelectedOptionsArray() {
      const arr = [];
      optionNames.forEach(function (name) {
        const input = form.querySelector('input[name="' + name + '"]:checked');
        arr.push(input ? input.value : null);
      });
      return arr;
    }

    function findVariant() {
      const selected = getSelectedOptionsArray();
      return variants.find(function (v) {
        return v.options && v.options.length === selected.length && v.options.every(function (opt, i) {
          return opt === selected[i];
        });
      });
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        setVariant(findVariant());
      });
    });
  }

  // Footer text-with-icons carousel: dot clicks scroll to slide; scroll syncs dots
  const footerCarousel = document.querySelector('[data-footer-carousel]');
  if (footerCarousel) {
    const list = footerCarousel.querySelector('[data-carousel-list]');
    const items = footerCarousel.querySelectorAll('[data-carousel-item]');
    const dots = footerCarousel.querySelectorAll('[data-carousel-dot]');
    if (list && items.length && items.length === dots.length) {
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          const item = items[index];
          if (item) {
            item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          }
        });
      });
      list.addEventListener('scroll', function () {
        const scrollLeft = list.scrollLeft;
        const itemWidth = items[0].offsetWidth;
        const index = Math.round(scrollLeft / itemWidth);
        const active = Math.min(Math.max(0, index), dots.length - 1);
        dots.forEach(function (d, i) {
          d.setAttribute('aria-selected', i === active ? 'true' : 'false');
        });
      });
    }
  }
})();
